import {
  GET_SALES_REPORT_DATETIME_DATA,
  GET_SALES_REPORT_GROUP_DATA,
  GET_SALES_REPORT_INDIVIDUAL_DATA,
  GET_SALES_REPORT_SUMMARY_DATA,
  SET_SALES_REPORT_BREADCRUMB_DATA,
  SET_SALES_REPORT_DATETIME_DATA,
  SET_SALES_REPORT_SELECTED_TAB_DATA,
  SET_SALES_REPORT_SUMMARY_DATA,
  SET_SALES_REPORT_TABLE_DATA,
  SET_SALES_REPORT_FILTER,
  CHECK_AGENT_IS_LEAF_NODE,
  GET_SALES_REPORT_POLICY_DATA,
  SET_SALES_REPORT_POLICY_DATA,
  SET_SALES_REPORT_SELECTED_BREADCRUMB_ID,
  SET_SALES_REPORT_PIE_CHART_DATA,
  GET_SALES_REPORT_PIE_CHART_DATA,
  RESET_STATE,
  FETCH_TEAM_POLICY_LIST_START,
  FETCH_TEAM_POLICY_LIST_SUCCESS,
} from './constants.js';

const getSalesReportDatetimeDataAction = (payload) => ({
  type: GET_SALES_REPORT_DATETIME_DATA,
  payload,
});

const setSalesReportDateTimeDataAction = (payload) => ({
  type: SET_SALES_REPORT_DATETIME_DATA,
  payload,
});

const checkAgentIsLeafNodeAction = (payload, callback) => ({
  type: CHECK_AGENT_IS_LEAF_NODE,
  payload,
  callback,
});

const getSalesReportGroupDataAction = (payload) => ({
  type: GET_SALES_REPORT_GROUP_DATA,
  payload,
});

const setSalesReportTableDataAction = (payload) => ({
  type: SET_SALES_REPORT_TABLE_DATA,
  payload,
});

const getSalesReportIndividualDataAction = (payload) => ({
  type: GET_SALES_REPORT_INDIVIDUAL_DATA,
  payload,
});

const setSalesReportSummaryDataAction = (payload) => ({
  type: SET_SALES_REPORT_SUMMARY_DATA,
  payload,
});

const getSalesReportSummaryDataAction = (payload) => ({
  type: GET_SALES_REPORT_SUMMARY_DATA,
  payload,
});

const setSalesReportPieChartDataAction = (payload) => ({
  type: SET_SALES_REPORT_PIE_CHART_DATA,
  payload,
});

const getSalesReportPieChartDataAction = (payload) => ({
  type: GET_SALES_REPORT_PIE_CHART_DATA,
  payload,
});

const setSalesReportBreadcrumbDataAction = (payload) => ({
  type: SET_SALES_REPORT_BREADCRUMB_DATA,
  payload,
});

const setSalesReportSelectedBreadcrumbIdAction = (payload) => ({
  type: SET_SALES_REPORT_SELECTED_BREADCRUMB_ID,
  payload,
});

const setSalesReportSelectedTabDataAction = (payload) => ({
  type: SET_SALES_REPORT_SELECTED_TAB_DATA,
  payload,
});

const setSalesReportConfigFilter = (payload) => ({
  type: SET_SALES_REPORT_FILTER,
  payload,
});

const getSalesReportPolicyAction = (payload) => ({
  type: GET_SALES_REPORT_POLICY_DATA,
  payload,
});

const setSalesReportPolicyAction = (payload) => ({
  type: SET_SALES_REPORT_POLICY_DATA,
  payload,
});

const resetStateAction = () => ({
  type: RESET_STATE,
});

const fetchTeamPolicyListStartAction = () => ({
  type: FETCH_TEAM_POLICY_LIST_START,
});

const fetchTeamPolicyListSuccessAction = () => ({
  type: FETCH_TEAM_POLICY_LIST_SUCCESS,
});

export {
  setSalesReportConfigFilter,
  getSalesReportDatetimeDataAction,
  setSalesReportDateTimeDataAction,
  getSalesReportGroupDataAction,
  setSalesReportTableDataAction,
  getSalesReportIndividualDataAction,
  getSalesReportSummaryDataAction,
  setSalesReportSummaryDataAction,
  getSalesReportPieChartDataAction,
  setSalesReportPieChartDataAction,
  setSalesReportBreadcrumbDataAction,
  setSalesReportSelectedBreadcrumbIdAction,
  getSalesReportPolicyAction,
  setSalesReportPolicyAction,
  setSalesReportSelectedTabDataAction,
  checkAgentIsLeafNodeAction,
  resetStateAction,
  fetchTeamPolicyListStartAction,
  fetchTeamPolicyListSuccessAction,
};
